// === Sentry (error tracking + tracing + logs) ===
// Init at top of file so it runs BEFORE the async IIFE (which awaits
// migrateLegacyVuexState). Errors during migration must be captured.
import * as Sentry from "@sentry/vue";

Sentry.init({
  // Vue 2: pass the Vue constructor (not an app instance — that's Vue 3)
  Vue,

  // DSN is a public key — safe to ship in JS bundle, but use env var for
  // environment-specific overrides (staging vs prod).
  dsn: process.env.VUE_APP_SENTRY_DSN_KAZANG_POS || "",

  // Environment / release tagging
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV || "production",
  release: process.env.VUE_APP_SENTRY_RELEASE || "kazangpos@1.0.0+sentry-v1",

  // Tracing (5% of transactions — fleet default for low-traffic internal app)
  integrations: [
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: Number(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE || 0.05),
  // Real production API domains read from src/services/GlobalVariables.js (line 29-62)
  // + grep for axios direct calls in src/store/modules/:
  //   - overflow.pos.co.zm   → Franchise_OnlineServer/proxyApi/* (main proxy backend)
  //   - lna.abc.co.zm        → kazangApi/api/paymentGateWay/* (direct payment API)
  //   - chrilantech.com      → LytSoftPosOnline/api/* (subscription emails)
  // Excluded: gatewaykazang.chrilantech.com (window.open redirect), sandboxkazang.abc.co.zm
  //           (sandbox redirect), kazang.chrilantech.com (custom-install redirect),
  //           zero.chrilantech.com (success URL placeholder).
  //
  // Gated on VUE_APP_SENTRY_TRACING_ENABLED: when unset / 'false', no sentry-trace
  // or baggage headers are sent on outgoing requests, so no CORS preflight is
  // triggered for them. This is the safe default until the backend CORS config
  // is updated to allow 'sentry-trace' and 'baggage' in Access-Control-Allow-Headers.
  // Set 'true' in production env after backend CORS update lands.
  tracePropagationTargets: process.env.VUE_APP_SENTRY_TRACING_ENABLED === 'true'
    ? [
        "localhost",
        /^https:\/\/overflow\.pos\.co\.zm\//,
        /^https:\/\/lna\.abc\.co\.zm\//,
        /^https:\/\/chrilantech\.com\//,
      ]
    : [],

  // Logs (v8 supports this)
  enableLogs: true,

  // PII controls — fleet convention
  dataCollection: {
    userInfo: false,
    httpBodies: [],
  },

  // Strip sensitive fields from event extras (mirror of Spring Boot SentryConfig)
  beforeSend(event) {
    if (event.extra) {
      delete event.extra.password;
      delete event.extra.apiKey;
      delete event.extra.authorization;
    }
    return event;
  },
});
// === End Sentry ===

import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js'
import DrawerLayout from 'vue-drawer-layout'
import './services/GlobalVariables'
import './services/ProxyHandler'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import VueToggles from 'vue-toggles';
import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import OneSignalVue from 'onesignal-vue'
import { migrateLegacyVuexState } from './services/migrateOldState';

Vue.use(OneSignalVue);

import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue);

import VueQriously from 'vue-qriously'

Vue.use(VueQriously)


// Import stylesheet
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueBarcodeScanner from 'vue-barcode-scanner'
let options = {
    sensitivity: 100, // default is 100
    requiredAttr: true, // default is false
    controlSequenceKeys: ['NumLock', 'Clear'], // default is null
    callbackAfterTimeout: true // default is false
}

Vue.use(VueBarcodeScanner, options);
Vue.component('loading', Loading);
Vue.component('VueToggles', VueToggles);
Vue.component('v-select',vSelect)
Vue.use(VueVirtualScroller)
Vue.use(DrawerLayout);
Vue.config.productionTip = false;

(async () => {
    await migrateLegacyVuexState();
    new Vue({ router, store, render: h => h(App) }).$mount('#app');
    console.log(navigator.storage)
    if (navigator.storage && navigator.storage.persist) {
        const isPersistent = await navigator.storage.persisted();
        console.log(`📦 Storage is ${isPersistent ? "already persistent" : "not persistent"}`);

        if (!isPersistent) {
            const granted = await navigator.storage.persist();
            if (granted) {
                console.log("✅ Persistent storage granted!");
            } else {
                console.warn("❌ Persistent storage NOT granted.");
            }
        }
    }
})();
